/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/9/5
 */
import config from 'crm/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    companyPermissions: {
        url: `${authApi}/api/company_permissions`,
        type: 'GET',
    },
    companyPermissionsUpdate: {
        url: `${authApi}/api/company_permissions/{id}`,
        type: 'PUT',
    },
    companyPermissionsCount: {
        url: `${authApi}/api/company_permissions/count`,
        type: 'GET',
    },
    companyPermissionsAll: {
        url: `${authApi}/api/company_permissions/all`,
        type: 'GET',
    },
}
